// Criteria types that trigger transient membership mode
const TRANSIENT_TRIGGER_TYPES = new Set(["location", "technographics", "realtimeSiteContent"]);

/**
 * Infer membership mode from v2.0 criteria groups.
 *
 * Returns "transient" if any criterion is a transient trigger type,
 * or if any sub-cohort has transient membership mode.
 * Otherwise returns "persistent".
 *
 * @param {Array<Array<Object>>} criteriaGroups - The criteria groups array
 * @param {function} getSubCohortMode - Function that takes a unique_id and returns the sub-cohort's resolved_membership_mode
 * @returns {"transient"|"persistent"}
 */
export const inferMembershipModeFromCriteria = (criteriaGroups, getSubCohortMode) => {
	for (const group of criteriaGroups) {
		for (const criteria of group) {
			if (TRANSIENT_TRIGGER_TYPES.has(criteria.type)) return "transient";
			if (criteria.type === "subCohorts" && criteria.data?.cohorts) {
				for (const cohort of criteria.data.cohorts) {
					if (getSubCohortMode(cohort.unique_id) === "transient") return "transient";
				}
			}
		}
	}
	return "persistent";
};
